import React from "react";

import { Limit } from "../model/Limit";

export const LimitContext = React.createContext<Limit[]>([]);
